import React from 'react'

const Privacy = () => {
  return (
    <div><h3>Privacy</h3><p>Manage your privacy settings.</p></div>
  )
}

export default Privacy